import { Table } from "antd";
import styled from "styled-components";
import { COLORS } from "../../../../../../layout/theme";

export const Container = styled.div`
	.ant-table-thead > tr > th {
		background: ${COLORS.Primary};

		&.statusColumn {
			background: ${COLORS.Secondary};
		}
	}

	.ant-table-cell-scrollbar:not([rowspan]) {
		background: ${COLORS.LightGrey3} !important;
	}

	.ant-table-thead
		> tr
		> th:not(:last-child):not(.ant-table-selection-column):not(
			.ant-table-row-expand-icon-cell
		):not([colspan])::before {
		background-color: ${COLORS.White};

		div {
			color: ${COLORS.White};
		}
	}

	thead {
		border-color: ${COLORS.White};
		border: 1px solid ${COLORS.White};
	}
`;

export const AntdTable = styled(Table)`
  .ant-table-thead > tr > th {
    background: ${COLORS.LightGrey3};
  }

  .ant-table-row {
    background: ${COLORS.White};
  }

  .ant-table-thead
    > tr
    > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
    background-color: ${COLORS.LightGrey3};

    div {
      color: ${COLORS.LightGrey3};
    }
  }

  .ant-table-container table > thead > tr:first-child th:first-child {
    border-radius: 20px 0 0 0;
  }

  .ant-table-container table > thead > tr:first-child th:last-child {
    border-radius: 0 20px 0 0;
  }

  }
`;

export const Section = styled.div`
	display: flex;
	flex-direction: column;
`;

export const TableContainer = styled.div`
	.ant-table table {
		background-color: ${COLORS.LightGrey} !important;
	}
`;
